module.exports = __webpack_public_path__ + "img/IMG_9683.16e648aa.jpg";